/* eslint-disable */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import { withRouter } from 'react-router';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from 'material-ui/Table';
import { CircularProgress } from 'material-ui/Progress';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button';
import { Tab, Tabs, TabList } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import Grid from 'material-ui/Grid';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import { Bar, Chart } from 'react-chartjs-2';

import Dialog from 'material-ui/Dialog/Dialog';
import DialogActions from 'material-ui/Dialog/DialogActions';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogContentText from 'material-ui/Dialog/DialogContentText';
import DialogTitle from 'material-ui/Dialog/DialogTitle';

import 'react-infinite-calendar/styles.css';

import { FiClock, FiDownload } from 'react-icons/fi';

import certificateIcon from '../assets/images/icons/certificate.png';
import chartIcon from '../assets/images/icons/chart.png';
import lockIcon from '../assets/images/icons/padlock.png';

import { lighten } from 'material-ui/styles/colorManipulator';

import TextField from 'material-ui/TextField';
import moment from 'moment';
import 'moment/locale/fr';
import * as XLSX from 'xlsx';

import blockchainLogo from '../assets/images/blockchain.png';
import certificateLogo from '../assets/images/certificate.png';

import { getUserKgOrPoundsOfCo2Unit } from '../utils/user/info';
import { convertKilogramsInUserUnit } from '../utils/unitHelper';

import {
  getCertificatesStart,
  certificatesTypeChanged,
  sortCertificates,
  generateCertificatePdf,
  generateYearlyCertificatePdf,
  retireCertificate,
  changePage,
  changeRowsPerPage,
  getCo2Data,
  toggleMatchingDateDialog,
  setMatchingDate,
  matching,
  toggleGenerateMatchingCertificates,
  toggleForceCertificatesGeneration,
  toggleWarningMatchingDialog,
  toggleSecretWordDialog,
  toggleHourlyCertificatesDialog,
  getHourlyCertificatesForDailyCertificate,
  getSecretWordForCertificate,
  getCertificatesForDate,
  downloadIrecFile,
  getIrecsStart,
  getUserRelatedUtilityOrganization,
  setLastCertificatesDataLoad,
} from '../actions';
import { translate } from 'react-i18next';
import { enums } from '../enums/index';
import { constants } from '../constants/index';
import {
  timestampInSecondToDateUTCDDMMYYYYHHmm,
  timestampInSecondToDayForDayListUTC,
  timestampInSecondToMonthUTC,
} from '../utils/date';

let counter = 0;

//the following variable currently corresponds to the newly created matching type named "last_month_hourly", but should change as soon as a we find a more meaningful name for this particular hourly/daily matching
const MATCHING_TYPE_HOURLY_DAILY_ID = '604627659837b761db757939';

function createData(name, id, fat, carbs, protein) {
  counter += 1;
  return { id: counter, name, id, fat, carbs, protein };
}

function filterCertificatesForDayYYYYMMDD(certificates, asset, dayYYYYMMDD) {
  let midnightOfCurrentDay = moment(dayYYYYMMDD, 'YYYY-MM-DD')
    .utc()
    .toDate();

  let lowerBoundForStartDateForCurrentDayUtc = moment(midnightOfCurrentDay)
    .subtract(12, 'hours')
    .add(1, 'ms')
    .utc()
    .toDate();
  let upperBoundForStartDateForCurrentDayUtc = moment(midnightOfCurrentDay)
    .add(12, 'hours')
    .utc()
    .toDate();

  return certificates.filter(certificate => {
    let certifUtcDateStart = moment
      .unix(certificate._productionDateStart)
      .utc()
      .toDate();

    return (
      certificate._consumptionAssetId === asset.id &&
      (certificate._assetConsumptionName === asset.name ||
        certificate._resourceName === asset.name) &&
      certifUtcDateStart >= lowerBoundForStartDateForCurrentDayUtc &&
      certifUtcDateStart <= upperBoundForStartDateForCurrentDayUtc
    );
  });
}

function filterCertificatesForMonthYYYYMM(certificates, asset, monthYYYYMM) {
  let midnightOfFirstDayOfMonth = moment(monthYYYYMM, 'YYYY-MM')
    .utc()
    .toDate();
  let midnightOfLastDayOfMonth = moment(monthYYYYMM, 'YYYY-MM')
    .endOf('month')
    .startOf('day')
    .utc()
    .toDate();

  let lowerBoundForStartDateForCurrentMonthUtc = moment(
    midnightOfFirstDayOfMonth
  )
    .subtract(12, 'hours')
    .add(1, 'ms')
    .utc()
    .toDate();
  let upperBoundForStartDateForCurrentMonthUtc = moment(
    midnightOfLastDayOfMonth
  )
    .add(12, 'hours')
    .utc()
    .toDate();

  return certificates.filter(certificate => {
    let certifUtcDateStart = moment
      .unix(certificate._productionDateStart)
      .utc()
      .toDate();

    return (
      certificate._consumptionAssetId === asset.id &&
      (certificate._assetConsumptionName === asset.name ||
        certificate._resourceName === asset.name) &&
      certifUtcDateStart >= lowerBoundForStartDateForCurrentMonthUtc &&
      certifUtcDateStart <= upperBoundForStartDateForCurrentMonthUtc
    );
  });
}

function filterCertificatesForYearYYYY(certificates, asset, yearYYYY) {
  let midnightOfFirstDayOfYear = moment(yearYYYY, 'YYYY')
    .utc()
    .toDate();
  let midnightOfLastDayOfYear = moment(yearYYYY, 'YYYY')
    .endOf('year')
    .startOf('day')
    .utc()
    .toDate();

  let lowerBoundForStartDateForCurrentYearUtc = moment(midnightOfFirstDayOfYear)
    .subtract(12, 'hours')
    .add(1, 'ms')
    .utc()
    .toDate();
  let upperBoundForStartDateForCurrentYearUtc = moment(midnightOfLastDayOfYear)
    .add(12, 'hours')
    .utc()
    .toDate();

  return certificates.filter(certificate => {
    let certifUtcDateStart = moment
      .unix(certificate._productionDateStart)
      .utc()
      .toDate();

    return (
      certificate._consumptionAssetId === asset.id &&
      (certificate._assetConsumptionName === asset.name ||
        certificate._resourceName === asset.name) &&
      certifUtcDateStart >= lowerBoundForStartDateForCurrentYearUtc &&
      certifUtcDateStart <= upperBoundForStartDateForCurrentYearUtc
    );
  });
}

class CertificatesHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order,
      orderBy,
      user,
      t,
      certificatesType,
      userRelatedUtilityOrganization,
    } = this.props;

    let co2Unit = getUserKgOrPoundsOfCo2Unit(user);

    let columnData = [];
    if (
      certificatesType === enums.CertificatesTypes.CONSUMPTION.value &&
      userRelatedUtilityOrganization &&
      userRelatedUtilityOrganization.matchingType &&
      userRelatedUtilityOrganization.matchingType._id.toString() ===
        MATCHING_TYPE_HOURLY_DAILY_ID
    ) {
      columnData = [
        {
          id: '_assetId',
          numeric: false,
          disablePadding: false,
          label: 'Production asset',
        },
        {
          id: '_consumptionAssetId',
          numeric: false,
          disablePadding: false,
          label: 'Consumption asset',
        },
        { id: '_owner', numeric: false, disablePadding: false, label: 'Owner' },
        {
          id: '_coSaved',
          numeric: true,
          disablePadding: false,
          label: 'Avoided CO2 in ' + co2Unit,
        },
        {
          id: '_powerInW',
          numeric: true,
          disablePadding: false,
          label: 'Power in kWh',
        },
        {
          id: '_productionDateStart',
          numeric: false,
          disablePadding: false,
          label: 'Date Start (UTC)',
        },
        {
          id: '_productionDateEnd',
          numeric: false,
          disablePadding: false,
          label: 'Date End (UTC)',
        },
        { id: '', numeric: false, disablePadding: false, label: 'Certificate' },
        {
          id: '',
          numeric: false,
          disablePadding: false,
          label: 'Hourly matching',
        },
        {
          id: '',
          numeric: false,
          disablePadding: false,
          label: 'Blockchain proof',
        },
        { id: '', numeric: false, disablePadding: false, label: 'Secret' },
      ];
    } else {
      columnData = [
        {
          id: '_assetId',
          numeric: false,
          disablePadding: false,
          label: 'Production asset',
        },
        {
          id: '_consumptionAssetId',
          numeric: false,
          disablePadding: false,
          label: 'Consumption asset',
        },
        { id: '_owner', numeric: false, disablePadding: false, label: 'Owner' },
        {
          id: '_coSaved',
          numeric: true,
          disablePadding: false,
          label: 'Avoided CO2 in ' + co2Unit,
        },
        {
          id: '_powerInW',
          numeric: true,
          disablePadding: false,
          label: 'Power in kWh',
        },
        {
          id: '_productionDateStart',
          numeric: false,
          disablePadding: false,
          label: 'Date Start (UTC)',
        },
        {
          id: '_productionDateEnd',
          numeric: false,
          disablePadding: false,
          label: 'Date End (UTC)',
        },
        { id: '', numeric: false, disablePadding: false, label: 'Certificate' },
        {
          id: '',
          numeric: false,
          disablePadding: false,
          label: 'Blockchain proof',
        },
        { id: '', numeric: false, disablePadding: false, label: 'Secret' },
      ];
    }

    if (user.roles.includes(enums.UserRole.SUPER_ADMIN)) {
      if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
        columnData = [
          {
            id: '_assetId',
            numeric: false,
            disablePadding: false,
            label: 'Production asset',
          },
          {
            id: '_consumptionAssetId',
            numeric: false,
            disablePadding: false,
            label: 'Consumption asset',
          },
          {
            id: '_owner',
            numeric: false,
            disablePadding: false,
            label: 'Owner',
          },
          {
            id: '_coSaved',
            numeric: true,
            disablePadding: false,
            label: 'Avoided CO2 in ' + co2Unit,
          },
          {
            id: '_powerInW',
            numeric: true,
            disablePadding: false,
            label: 'Power in kWh',
          },
          {
            id: '_productionDateStart',
            numeric: false,
            disablePadding: false,
            label: 'Date Start (UTC)',
          },
          {
            id: '_productionDateEnd',
            numeric: false,
            disablePadding: false,
            label: 'Date End (UTC)',
          },
          {
            id: '_creationTime',
            numeric: false,
            disablePadding: false,
            label: 'Creation date',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Certificate',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Hourly matching',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Blockchain proof',
          },
          { id: '', numeric: false, disablePadding: false, label: 'Secret' },
        ];
      } else {
        columnData = [
          {
            id: '_assetId',
            numeric: false,
            disablePadding: false,
            label: 'Production asset',
          },
          {
            id: '_consumptionAssetId',
            numeric: false,
            disablePadding: false,
            label: 'Consumption asset',
          },
          {
            id: '_owner',
            numeric: false,
            disablePadding: false,
            label: 'Owner',
          },
          {
            id: '_coSaved',
            numeric: true,
            disablePadding: false,
            label: 'Avoided CO2 in ' + co2Unit,
          },
          {
            id: '_powerInW',
            numeric: true,
            disablePadding: false,
            label: 'Power in kWh',
          },
          {
            id: '_productionDateStart',
            numeric: false,
            disablePadding: false,
            label: 'Date Start (UTC)',
          },
          {
            id: '_productionDateEnd',
            numeric: false,
            disablePadding: false,
            label: 'Date End (UTC)',
          },
          {
            id: '_creationTime',
            numeric: false,
            disablePadding: false,
            label: 'Creation date',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Certificate',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Blockchain proof',
          },
          { id: '', numeric: false, disablePadding: false, label: 'Secret' },
        ];
      }
    }

    if (user.roles.includes(enums.UserRole.CUSTOMER)) {
      if (
        certificatesType === enums.CertificatesTypes.CONSUMPTION.value &&
        userRelatedUtilityOrganization &&
        userRelatedUtilityOrganization.matchingType &&
        userRelatedUtilityOrganization.matchingType._id.toString() ===
          MATCHING_TYPE_HOURLY_DAILY_ID
      ) {
        columnData = [
          {
            id: '_assetId',
            numeric: false,
            disablePadding: false,
            label: 'Production asset',
          },
          {
            id: '_consumptionAssetId',
            numeric: false,
            disablePadding: false,
            label: 'Consumption asset',
          },
          {
            id: '_coSaved',
            numeric: true,
            disablePadding: false,
            label: 'Avoided CO2 in ' + co2Unit,
          },
          {
            id: '_powerInW',
            numeric: true,
            disablePadding: false,
            label: 'Power in kWh',
          },
          {
            id: '_productionDateStart',
            numeric: false,
            disablePadding: false,
            label: 'Date Start (UTC)',
          },
          {
            id: '_productionDateEnd',
            numeric: false,
            disablePadding: false,
            label: 'Date End (UTC)',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Certificate',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Hourly matching',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Blockchain proof',
          },
          { id: '', numeric: false, disablePadding: false, label: 'Secret' },
        ];
      } else {
        columnData = [
          {
            id: '_assetId',
            numeric: false,
            disablePadding: false,
            label: 'Production asset',
          },
          {
            id: '_consumptionAssetId',
            numeric: false,
            disablePadding: false,
            label: 'Consumption asset',
          },
          {
            id: '_coSaved',
            numeric: true,
            disablePadding: false,
            label: 'Avoided CO2 in ' + co2Unit,
          },
          {
            id: '_powerInW',
            numeric: true,
            disablePadding: false,
            label: 'Power in kWh',
          },
          {
            id: '_productionDateStart',
            numeric: false,
            disablePadding: false,
            label: 'Date Start (UTC)',
          },
          {
            id: '_productionDateEnd',
            numeric: false,
            disablePadding: false,
            label: 'Date End (UTC)',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Certificate',
          },
          {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Blockchain proof',
          },
          { id: '', numeric: false, disablePadding: false, label: 'Secret' },
        ];
      }
    }

    return (
      <TableHead>
        {!userRelatedUtilityOrganization &&
          !user.roles.includes(enums.UserRole.SUPER_ADMIN) && (
            <CircularProgress size={16} style={{ marginLeft: 10 }} />
          )}
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t('Sort')}
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

CertificatesHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  certificatesType: PropTypes.string.isRequired,
  userRelatedUtilityOrganization: PropTypes.string.isRequired,
};

class IrecsHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, t } = this.props;

    let columnData = [
      {
        id: '_country',
        numeric: false,
        disablePadding: false,
        label: 'Country',
      },
      {
        id: '_year',
        numeric: true,
        disablePadding: false,
        label: 'Year',
      },
      {
        id: '_asset',
        numeric: false,
        disablePadding: false,
        label: 'Asset',
      },
      {
        id: '_customerOrganization',
        numeric: false,
        disablePadding: false,
        label: 'Customer Organization',
      },
      {
        id: '_volume',
        numeric: true,
        disablePadding: false,
        label: 'Volume',
      },
      {
        id: '_file',
        numeric: false,
        disablePadding: false,
        label: 'File',
      },
    ];

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t('Sort')}
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

IrecsHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

const exportCertificates = (allCertificates, props, certificatesType) => {
  const { t, matchingFrequency, user } = props;
  let co2Unit = getUserKgOrPoundsOfCo2Unit(user);

  let assets = [];

  // filter certificates
  let certificates = allCertificates.filter(c => !c._retired);

  let dataToExport = [];
  if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
    dataToExport = [
      [
        'Owner',
        'Consumption site',
        'Granularity',
        'Asset',
        t('Tracked avoided CO2 emissions') + ' (' + co2Unit + ')',
        'Power in Wh',
        'Date Start',
        'Date End',
        'Transaction url',
      ],
    ];
  } else if (certificatesType === enums.CertificatesTypes.PRODUCTION.value) {
    dataToExport = [
      [
        'Owner',
        'Granularity',
        'Asset',
        t('Tracked avoided CO2 emissions') + ' (' + co2Unit + ')',
        'Power in Wh',
        'Date Start',
        'Date End',
        'Transaction url',
      ],
    ];
  }

  //All certificates
  for (let i = 0; i < certificates.length; i++) {
    let exportLine = [];
    let [co2QuantityInUserUnitForExport, userUnit] = convertKilogramsInUserUnit(
      certificates[i].co2SavedTemp,
      user
    );
    if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
      exportLine = [
        certificates[i]._ownerName,
        certificates[i]._assetConsumptionName,
        matchingFrequency === enums.FrequencyTypes.DAILY || !matchingFrequency
          ? 'Daily'
          : 'Monthly',
        certificates[i]._resourceName,
        co2QuantityInUserUnitForExport,
        certificates[i]._powerInW,
        timestampInSecondToDateUTCDDMMYYYYHHmm(
          certificates[i]._productionDateStart,
          props.i18n
        ),
        timestampInSecondToDateUTCDDMMYYYYHHmm(
          certificates[i]._productionDateEnd,
          props.i18n
        ),
        certificates[i].transactionUrl,
      ];
    } else if (certificatesType === enums.CertificatesTypes.PRODUCTION.value) {
      exportLine = [
        certificates[i]._ownerName,
        matchingFrequency === enums.FrequencyTypes.DAILY || !matchingFrequency
          ? 'Daily'
          : 'Monthly',
        certificates[i]._resourceName,
        co2QuantityInUserUnit,
        certificates[i]._powerInW,
        timestampInSecondToDateUTCDDMMYYYYHHmm(
          certificates[i]._productionDateStart,
          props.i18n
        ),
        timestampInSecondToDateUTCDDMMYYYYHHmm(
          certificates[i]._productionDateEnd,
          props.i18n
        ),
        certificates[i].transactionUrl,
      ];
    }

    dataToExport.push(exportLine);

    //
    let assetCheck = assets.find(cA => {
      return (
        cA.id === certificates[i]._consumptionAssetId &&
        (cA.name === certificates[i]._resourceName ||
          cA.name === certificates[i]._assetConsumptionName)
      );
    });
    if (!assetCheck)
      assets.push({
        id: certificates[i]._consumptionAssetId,
        name:
          certificates[i]._consumptionAssetId === -1
            ? certificates[i]._resourceName
            : certificates[i]._assetConsumptionName,
        owner: certificates[i]._ownerName,
      });
  }
  //Monthly certificates
  let sortedCertificates = certificates.sort((a, b) => {
    return a._productionDateEnd - b._productionDateEnd;
  });

  let lastMonth = timestampInSecondToDayForDayListUTC(
    sortedCertificates[sortedCertificates.length - 1]._productionDateEnd
  );
  let firstMonth =
    matchingFrequency === enums.FrequencyTypes.DAILY || !matchingFrequency
      ? timestampInSecondToDayForDayListUTC(
          sortedCertificates[0]._productionDateEnd
        )
      : timestampInSecondToDayForDayListUTC(
          sortedCertificates[0]._productionDateStart
        );

  let dateStartMonthMoment = moment(firstMonth);
  let dateEndMonthMoment = moment(lastMonth);
  let months = [];

  while (
    dateEndMonthMoment > dateStartMonthMoment ||
    dateStartMonthMoment.format('M') === dateEndMonthMoment.format('M')
  ) {
    months.push(dateStartMonthMoment.format('YYYY-MM'));
    dateStartMonthMoment.add(1, 'month');
  }

  let dateStartYearMoment = moment(firstMonth);
  let dateEndYearMoment = moment(lastMonth);
  let years = [];

  while (
    dateEndYearMoment > dateStartYearMoment ||
    dateStartYearMoment.format('YYYY') === dateEndYearMoment.format('YYYY')
  ) {
    years.push(dateStartYearMoment.format('YYYY'));
    dateStartYearMoment.add(1, 'year');
  }

  let dateStartDayMoment = moment(firstMonth);
  let dateEndDayMoment = moment(lastMonth);
  let days = [];

  let j = 0;

  while (
    dateEndDayMoment > dateStartDayMoment ||
    dateStartDayMoment.format('D') === dateEndDayMoment.format('D')
  ) {
    days.push(dateStartDayMoment.format('YYYY-MM-DD'));
    dateStartDayMoment.add(1, 'day');
    j++;
  }

  if (matchingFrequency === enums.FrequencyTypes.DAILY || !matchingFrequency) {
    days.map(day => {
      let dailyTotal = 0;
      let dailyCo2Total = 0;
      assets.map(cA => {
        let dailyTotalForAsset = 0;
        let dailyTotalCo2ForAsset = 0;
        let certificatesForDay = filterCertificatesForDayYYYYMMDD(
          sortedCertificates,
          cA,
          day
        );

        certificatesForDay.map(c => {
          let [co2QuantityInUserUnitDay, userUnit] = convertKilogramsInUserUnit(
            c.co2SavedTemp,
            user
          );
          dailyTotalForAsset += c._powerInW;
          dailyTotalCo2ForAsset += co2QuantityInUserUnitDay;
          dailyTotal += c._powerInW;
          dailyCo2Total += co2QuantityInUserUnitDay;
        });
        let exportLineAssetDay = [];
        if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
          exportLineAssetDay = [
            cA.owner,
            cA.id === -1 ? '' : cA.name,
            'Daily',
            cA.id === -1 ? cA.name : '',
            parseInt(dailyTotalCo2ForAsset, 10),
            dailyTotalForAsset,
            day,
            '',
          ];
        } else if (
          certificatesType === enums.CertificatesTypes.PRODUCTION.value
        ) {
          exportLineAssetDay = [
            cA.owner,
            'Daily',
            cA.id === -1 ? cA.name : '',
            parseInt(dailyTotalCo2ForAsset, 10),
            dailyTotalForAsset,
            day,
            '',
          ];
        }

        if (dailyTotalForAsset > 0) {
          dataToExport.push(exportLineAssetDay);
        }
      });
      let exportLineTotalDay = [];
      if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
        exportLineTotalDay = [
          '',
          'Total',
          'Daily',
          '',
          parseInt(dailyCo2Total, 10),
          dailyTotal,
          day,
          '',
          '',
        ];
      } else if (
        certificatesType === enums.CertificatesTypes.PRODUCTION.value
      ) {
        exportLineTotalDay = [
          'Total',
          'Daily',
          '',
          parseInt(dailyCo2Total, 10),
          dailyTotal,
          day,
          '',
          '',
        ];
      }

      if (dailyTotal > 0) {
        dataToExport.push(exportLineTotalDay);
      }
    });
  }

  months.map(month => {
    let monthlyTotal = 0;
    let monthlyCo2Total = 0;
    assets.map(cA => {
      let monthlyTotalForAsset = 0;
      let monthlyTotalCo2ForAsset = 0;
      let certificatesForMonth = filterCertificatesForMonthYYYYMM(
        sortedCertificates,
        cA,
        month
      );

      certificatesForMonth.map(c => {
        let [co2QuantityInUserUnitMonth, userUnit] = convertKilogramsInUserUnit(
          c.co2SavedTemp,
          user
        );
        monthlyTotalForAsset += c._powerInW;
        monthlyTotalCo2ForAsset += co2QuantityInUserUnitMonth;
        monthlyTotal += c._powerInW;
        monthlyCo2Total += co2QuantityInUserUnitMonth;
      });

      let exportLineAssetMonth = [];
      if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
        exportLineAssetMonth = [
          cA.owner,
          cA.id === -1 ? '' : cA.name,
          'Monthly',
          cA.id === -1 ? cA.name : '',
          parseInt(monthlyTotalCo2ForAsset, 10),
          monthlyTotalForAsset,
          month,
          '',
          '',
        ];
      } else if (
        certificatesType === enums.CertificatesTypes.PRODUCTION.value
      ) {
        exportLineAssetMonth = [
          cA.owner,
          'Monthly',
          cA.id === -1 ? cA.name : '',
          parseInt(monthlyTotalCo2ForAsset, 10),
          monthlyTotalForAsset,
          month,
          '',
          '',
        ];
      }

      if (monthlyTotalForAsset > 0) {
        dataToExport.push(exportLineAssetMonth);
      }
    });

    let exportLineTotalMonth = [];
    if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
      exportLineTotalMonth = [
        '',
        'Total',
        'Monthly',
        '',
        parseInt(monthlyCo2Total, 10),
        monthlyTotal,
        month,
        '',
        '',
      ];
    } else if (certificatesType === enums.CertificatesTypes.PRODUCTION.value) {
      exportLineTotalMonth = [
        'Total',
        'Monthly',
        '',
        parseInt(monthlyCo2Total, 10),
        monthlyTotal,
        month,
        '',
        '',
      ];
    }
    if (monthlyTotal > 0) {
      dataToExport.push(exportLineTotalMonth);
    }
  });

  years.map(year => {
    let yearlyTotal = 0;
    let yearlyCo2Total = 0;
    assets.map(cA => {
      let yearlyTotalForAsset = 0;
      let yearlyTotalCo2ForAsset = 0;

      let certificatesForYear = filterCertificatesForYearYYYY(
        sortedCertificates,
        cA,
        year
      );

      certificatesForYear.map(c => {
        let [co2QuantityInUserUnitYear, userUnit] = convertKilogramsInUserUnit(
          c.co2SavedTemp,
          user
        );
        yearlyTotalForAsset += c._powerInW;
        yearlyTotalCo2ForAsset += co2QuantityInUserUnitYear;
        yearlyTotal += c._powerInW;
        yearlyCo2Total += co2QuantityInUserUnitYear;
      });

      let exportLineAssetYear = [];
      if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
        exportLineAssetYear = [
          cA.owner,
          cA.id === -1 ? '' : cA.name,
          'Yearly',
          cA.id === -1 ? cA.name : '',
          parseInt(yearlyTotalCo2ForAsset, 10),
          yearlyTotalForAsset,
          year,
          '',
          '',
        ];
      } else if (
        certificatesType === enums.CertificatesTypes.PRODUCTION.value
      ) {
        exportLineAssetYear = [
          cA.owner,
          'Yearly',
          cA.id === -1 ? cA.name : '',
          parseInt(yearlyTotalCo2ForAsset, 10),
          yearlyTotalForAsset,
          year,
          '',
          '',
        ];
      }
      if (yearlyTotalForAsset > 0) {
        dataToExport.push(exportLineAssetYear);
      }
    });
    let exportLineTotalYear = [];
    if (certificatesType === enums.CertificatesTypes.CONSUMPTION.value) {
      exportLineTotalYear = [
        '',
        'Total',
        'yearly',
        '',
        parseInt(yearlyCo2Total, 10),
        yearlyTotal,
        year,
        '',
        '',
      ];
    } else if (certificatesType === enums.CertificatesTypes.PRODUCTION.value) {
      exportLineTotalYear = [
        'Total',
        'yearly',
        '',
        parseInt(yearlyCo2Total, 10),
        yearlyTotal,
        year,
        '',
        '',
      ];
    }
    if (yearlyTotal > 0) {
      dataToExport.push(exportLineTotalYear);
    }
  });

  // BUILD SHEET

  if (dataToExport && dataToExport.length > 0) {
    // generate worksheet
    const ws = XLSX.utils.aoa_to_sheet(dataToExport);

    // generate workbook and add the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // save to file
    XLSX.writeFile(wb, 'attributes-data-export-certificates.xlsx');
  }
};

let CertificatesToolbar = props => {
  const {
    numSelected,
    classes,
    loading,
    loadingCo2,
    t,
    certificates,
    loadingIrecs,
    certificatesType,
  } = props;

  const certificatesForExport = certificates
    ? certificates.map(certificate => {
        let explorerUrl;
        switch (certificate._info) {
          case enums.SmartContractVersion.EWC:
          case enums.SmartContractVersion.V3:
            explorerUrl = enums.BlockchainExplorerUrl.EWC;
            break;
          case enums.SmartContractVersion.VOLTA:
            explorerUrl = enums.BlockchainExplorerUrl.VOLTA;
            break;
          default:
            explorerUrl = enums.BlockchainExplorerUrl.TOBALABA;
            break;
        }
        certificate.transactionUrl = `${explorerUrl}/tx/${certificate._txHash}`;
        return certificate;
      })
    : [];

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            <img
              src={certificateIcon}
              style={{
                maxHeight: 20,
                position: 'relative',
                top: 3,
                marginRight: 10,
              }}
            />
            {t('High Fidelity Green Energy Certificates')}
            {(loading || loadingCo2 || loadingIrecs) && (
              <CircularProgress size={16} style={{ marginLeft: 10 }} />
            )}
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {!(loading || loadingCo2) && (
          <Tooltip title={t('Export data')}>
            <IconButton
              aria-label="Export data"
              onClick={() =>
                exportCertificates(
                  certificatesForExport,
                  props,
                  certificatesType
                )
              }
            >
              <FiDownload style={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

CertificatesToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

CertificatesToolbar = withStyles(toolbarStyles)(CertificatesToolbar);

let IrecsToolbar = props => {
  const { numSelected, classes, loading, loadingCo2, loadingIrecs, t } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            <img
              src={certificateIcon}
              style={{
                maxHeight: 20,
                position: 'relative',
                top: 3,
                marginRight: 10,
              }}
            />
            {t('Irecs')}
            {(loading || loadingCo2 || loadingIrecs) && (
              <CircularProgress size={16} style={{ marginLeft: 10 }} />
            )}
          </Typography>
        )}
      </div>
    </Toolbar>
  );
};

IrecsToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

IrecsToolbar = withStyles(toolbarStyles)(IrecsToolbar);

const styles = theme => ({
  root: {
    width: '99%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    //minWidth: 700,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  indentedContent: {
    marginLeft: 10,
    marginBottom: 20,
  },
  inputWithMargin: {
    marginRight: 15,
  },
  tabList: {
    borderBottom: '4px solid #F87733',
    margin: '0 0 10px',
    padding: 0,
  },
  tab: {
    fontSize: '1rem',
    fontFamily:
      '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
    display: 'inline-block',
    border: '1px solid transparent',
    borderBottom: 'none',
    bottom: '-1px',
    position: 'relative',
    listStyle: 'none',
    padding: '8px 16px',
    margin: '0px 24px 0px 0px',
    cursor: 'pointer',
  },
  tabSelected: {
    background: '#F87733',
    borderColor: '#F87733',
    color: 'white',
    borderRadius: '0px 0px 0 0',
  },
  tabDisabled: {
    color: 'black',
    cursor: 'default',
  },
});

class Certificates extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      certificatesType: enums.CertificatesTypes.CONSUMPTION.value,
      order: 'desc',
      orderBy: '_productionDateEnd',
      selected: [],
      data: [
        createData('Frasnes', 0, 3.7, 67, 4.3),
        createData('Fontanelles', 1, 25.0, 51, 4.9),
        createData('Eget', 2, 16.0, 24, 6.0),
        createData('Burgum', 3, 6.0, 24, 4.0),
        createData('Marèges', 4, 16.0, 49, 3.9),
      ].sort((a, b) => (a.id < b.id ? -1 : 1)),
      page: 0,
      rowsPerPage: 5,
      open: false,
    };
  }

  handleCertificatesTypeChange = newValue => {
    this.setState({ certificatesType: newValue });
    this.props.certificatesTypeChanged(newValue);
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClickMatchingDateOpen = matchingDate => {
    this.props.toggleMatchingDateDialog();
  };

  handleMatchingCertificateGeneration = () => {
    this.props.toggleGenerateMatchingCertificates();
  };

  handleForceCertificatesGeneration = () => {
    this.props.toggleForceCertificatesGeneration();
  };

  handleClickMatchingDateClose = () => {
    this.props.toggleMatchingDateDialog();
  };

  componentDidMount = async () => {
    const { isAuthenticated, user, lastCertificatesDataLoad } = this.props;

    const now = moment();
    const then = moment.unix(lastCertificatesDataLoad);
    const delta = now.diff(then, 'milliseconds');

    if (!isAuthenticated || !user) {
      this.props.history.push('/');
    } else {
      if (delta && delta > 60 * 60 * 1000) {
        //Reload if last certificates data load > 1 hour
        await this.props.getUserRelatedUtilityOrganization();
        await this.props.getCertificatesStart();
        await this.props.getIrecsStart();
        this.props.setLastCertificatesDataLoad();
      }
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.props.orderBy === property && this.props.order === 'desc') {
      order = 'asc';
    }

    const certificates =
      order === 'desc'
        ? this.props.certificates.sort((a, b) =>
            b[orderBy] < a[orderBy] ? -1 : 1
          )
        : this.props.certificates.sort((a, b) =>
            a[orderBy] < b[orderBy] ? -1 : 1
          );

    this.props.sortCertificates(certificates, order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  handleOpenSecretWordDialog = async (certificate, t) => {
    this.props.toggleSecretWordDialog();
    this.props.getSecretWordForCertificate(certificate);
  };

  handleOpenHourlyCertificatesDialog = async certificate => {
    this.props.toggleHourlyCertificatesDialog();
    this.props.getHourlyCertificatesForDailyCertificate(certificate);
  };

  handleGenerateCertificatePdf = (
    certificate,
    assetName,
    ownerName,
    owner,
    co2Saved,
    co2SavedUnit,
    t,
    i18n
  ) => {
    this.props.generateCertificatePdf(
      certificate,
      assetName,
      ownerName,
      owner,
      co2Saved,
      co2SavedUnit,
      t,
      i18n
    );
  };

  handleDownloadIrecFile = (fileName, customerOrganizationId) => {
    this.props.downloadIrecFile(fileName, customerOrganizationId);
  };

  handleGenerateYearlyCertificatePdfForTheNtLastYear = (
    certificates,
    year,
    t
  ) => {
    this.props.generateYearlyCertificatePdf(certificates, year, t);
  };

  handleRetireCertificate = (certificateId, owner, t, certificate) => {
    this.props.retireCertificate(certificateId, owner, t, certificate._assetId);
  };

  //Below are functions provided initially by material ui
  //Visit https://material-ui-next.com/demos/tables/#sorting-amp-selecting for details

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.state.data.map(n => n.id) }); //Do this redux way
      return;
    }
    this.setState({ selected: [] }); //Do this redux way
  };

  handleClickSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPage(event.target.value);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  renderSecretWordButton(certificate, t) {
    if (
      constants.CertificateWithSecretVersionTypes.includes(certificate._info)
    ) {
      return (
        <Button
          onClick={event => {
            this.handleOpenSecretWordDialog(certificate, t);
          }}
        >
          <img
            src={lockIcon}
            alt={'Get secret word'}
            title={'Get secret word'}
            style={{ width: 24, height: 24 }}
          />
        </Button>
      );
    }
  }

  renderCertificatesList(certificatesWithCo2) {
    const {
      classes,
      certificates,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      loading,
      loadingCo2,
      loadingIrecs,
      retiringCertificateId,
      username,
      user,
      co2Data,
      t,
      i18n,
      userRelatedUtilityOrganization,
    } = this.props;

    if (loading || loadingCo2 || loadingIrecs) {
      return false;
    }

    let dateTimeFormat = 'YYYY-MM-DD HH:mm'; //English date
    if (i18n.language === 'fr') {
      dateTimeFormat = 'DD-MM-YYYY HH:mm';
    } else if (i18n.language === 'en_us') {
      dateTimeFormat = 'MM-DD-YYYY h:mm a'; //American date
    }

    let sliceToDisplay = certificatesWithCo2
      ? certificatesWithCo2.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )
      : [];

    let formatCO2SavedTemp = (loadingCo2, n) => {
      if (loadingCo2) {
        return 'loading';
      } else {
        let [
          co2QuantityInUserUnitFormatted,
          userUnit,
        ] = convertKilogramsInUserUnit(n.co2SavedTemp, user);
        let parsedCO2SavedTemp = parseInt(co2QuantityInUserUnitFormatted);
        if (!isNaN(parsedCO2SavedTemp)) {
          return parsedCO2SavedTemp.toLocaleString('en-US');
        }
      }
    };

    return sliceToDisplay.map((n, index) => {
      const isSelected = this.isSelected(n.id);
      let dateProduction = t('YYYY-MM-DD HH:mm');

      let explorerUrl;
      switch (n._info) {
        case enums.SmartContractVersion.EWC:
        case enums.SmartContractVersion.V3:
          explorerUrl = enums.BlockchainExplorerUrl.EWC;
          break;
        case enums.SmartContractVersion.VOLTA:
          explorerUrl = enums.BlockchainExplorerUrl.VOLTA;
          break;
        default:
          explorerUrl = enums.BlockchainExplorerUrl.TOBALABA;
          break;
      }
      if (user.roles.includes('customer')) {
        return (
          <TableRow
            hover
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            key={index}
            selected={isSelected}
          >
            <TableCell
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {n._resourceName}
              {n._retired ? ' (retired)' : ''}
            </TableCell>
            <TableCell
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {n._assetConsumptionName}
            </TableCell>

            <TableCell
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {formatCO2SavedTemp(loadingCo2, n)}
            </TableCell>
            <TableCell
              numeric
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {(n._powerInW / 1000).toLocaleString('en-US')}
            </TableCell>
            <TableCell
              numeric
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
                minWidth: '150px',
              }}
            >
              {timestampInSecondToDateUTCDDMMYYYYHHmm(
                n._productionDateStart,
                this.props.i18n
              )}
            </TableCell>
            <TableCell
              numeric
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
                minWidth: '150px',
              }}
            >
              {timestampInSecondToDateUTCDDMMYYYYHHmm(
                n._productionDateEnd,
                this.props.i18n
              )}
            </TableCell>
            <TableCell>
              <Button
                onClick={event => {
                  let [
                    co2QuantityInUserUnitPdf,
                    userUnitPdf,
                  ] = convertKilogramsInUserUnit(n.co2SavedTemp, user);
                  this.handleGenerateCertificatePdf(
                    n,
                    n._resourceName,
                    n._ownerName,
                    n._owner,
                    co2QuantityInUserUnitPdf,
                    userUnitPdf,
                    t,
                    this.props.i18n
                  );
                }}
              >
                <img
                  src={certificateLogo}
                  alt={'Download certificate ' + n._certificateId}
                  title={'Download certificate ' + n._certificateId}
                  style={{ width: 24, height: 24 }}
                />
              </Button>
            </TableCell>
            {this.state.certificatesType ===
              enums.CertificatesTypes.CONSUMPTION.value &&
              userRelatedUtilityOrganization &&
              userRelatedUtilityOrganization.matchingType &&
              userRelatedUtilityOrganization.matchingType._id.toString() ===
                MATCHING_TYPE_HOURLY_DAILY_ID && (
                <TableCell>
                  {n.frequency === enums.FrequencyTypes.DAILY &&
                    n.utilityOrganization &&
                    n.utilityOrganization.type ===
                      enums.OrganizationTypes.UTILITY &&
                    n.utilityOrganization.matchingType.toString() ===
                      MATCHING_TYPE_HOURLY_DAILY_ID && (
                      <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={event => {
                          this.handleOpenHourlyCertificatesDialog(n);
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}
                </TableCell>
              )}
            <TableCell>
              <a href={`${explorerUrl}/tx/${n._txHash}`} target="_blank">
                <img
                  src={blockchainLogo}
                  alt="check transaction"
                  title={t('check transaction')}
                  style={{ width: 24, height: 24 }}
                />
              </a>
            </TableCell>
            <TableCell>{this.renderSecretWordButton(n, t)}</TableCell>
          </TableRow>
        );
      }

      if (user.roles.includes(enums.UserRole.SUPER_ADMIN)) {
        return (
          <TableRow
            hover
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            key={index}
            selected={isSelected}
          >
            <TableCell
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {n._resourceName}
              {n._retired ? ' (retired)' : ''}
            </TableCell>
            <TableCell
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {n._assetConsumptionName}
            </TableCell>
            <TableCell
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {n._ownerName}
            </TableCell>
            <TableCell
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {formatCO2SavedTemp(loadingCo2, n)}
            </TableCell>
            <TableCell
              numeric
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
              }}
            >
              {(n._powerInW / 1000).toLocaleString('en-US')}
            </TableCell>
            <TableCell
              numeric
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
                minWidth: '150px',
              }}
            >
              {timestampInSecondToDateUTCDDMMYYYYHHmm(
                n._productionDateStart,
                this.props.i18n
              )}
            </TableCell>
            <TableCell
              numeric
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
                minWidth: '150px',
              }}
            >
              {timestampInSecondToDateUTCDDMMYYYYHHmm(
                n._productionDateEnd,
                this.props.i18n
              )}
            </TableCell>
            <TableCell
              numeric
              style={{
                color: n._retired ? 'rgb(206, 206, 206)' : '',
                cursor: 'pointer',
                minWidth: '150px',
              }}
            >
              {moment(n._creationTime).format(dateTimeFormat)}
            </TableCell>
            <TableCell>
              <Button
                onClick={event => {
                  let [
                    co2QuantityInUserUnitPdf,
                    userUnitPdf,
                  ] = convertKilogramsInUserUnit(n.co2SavedTemp, user);
                  this.handleGenerateCertificatePdf(
                    n,
                    n._resourceName,
                    n._ownerName,
                    n._owner,
                    co2QuantityInUserUnitPdf,
                    userUnitPdf,
                    t,
                    this.props.i18n
                  );
                }}
              >
                <img
                  src={certificateLogo}
                  alt={'Download certificate ' + n._certificateId}
                  title={'Download certificate ' + n._certificateId}
                  style={{ width: 24, height: 24 }}
                />
              </Button>
            </TableCell>
            {this.state.certificatesType ===
              enums.CertificatesTypes.CONSUMPTION.value && (
              <TableCell>
                {n.frequency === enums.FrequencyTypes.DAILY &&
                  n.utilityOrganization &&
                  n.utilityOrganization.type ===
                    enums.OrganizationTypes.UTILITY &&
                  n.utilityOrganization.matchingType.toString() ===
                    MATCHING_TYPE_HOURLY_DAILY_ID && (
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={event => {
                        this.handleOpenHourlyCertificatesDialog(n);
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  )}
              </TableCell>
            )}
            <TableCell>
              <a href={`${explorerUrl}/tx/${n._txHash}`} target="_blank">
                <img
                  src={blockchainLogo}
                  alt="check transaction"
                  title={t('check transaction')}
                  style={{ width: 24, height: 24 }}
                />
              </a>
            </TableCell>
            <TableCell>{this.renderSecretWordButton(n, t)}</TableCell>
          </TableRow>
        );
      }

      return (
        <TableRow
          hover
          role="checkbox"
          aria-checked={isSelected}
          tabIndex={-1}
          key={index}
          selected={isSelected}
        >
          <TableCell
            style={{
              color: n._retired ? 'rgb(206, 206, 206)' : '',
              cursor: 'pointer',
            }}
          >
            {n._resourceName}
            {n._retired ? ' (retired)' : ''}
          </TableCell>
          <TableCell
            style={{
              color: n._retired ? 'rgb(206, 206, 206)' : '',
              cursor: 'pointer',
            }}
          >
            {n._assetConsumptionName}
          </TableCell>
          <TableCell
            style={{
              color: n._retired ? 'rgb(206, 206, 206)' : '',
              cursor: 'pointer',
            }}
          >
            {n._ownerName}
          </TableCell>
          <TableCell
            style={{
              color: n._retired ? 'rgb(206, 206, 206)' : '',
              cursor: 'pointer',
            }}
          >
            {formatCO2SavedTemp(loadingCo2, n)}
          </TableCell>
          <TableCell
            numeric
            style={{
              color: n._retired ? 'rgb(206, 206, 206)' : '',
              cursor: 'pointer',
            }}
          >
            {(n._powerInW / 1000).toLocaleString('en-US')}
          </TableCell>
          <TableCell
            numeric
            style={{
              color: n._retired ? 'rgb(206, 206, 206)' : '',
              cursor: 'pointer',
              minWidth: '150px',
            }}
          >
            {timestampInSecondToDateUTCDDMMYYYYHHmm(
              n._productionDateStart,
              this.props.i18n
            )}
          </TableCell>
          <TableCell
            numeric
            style={{
              color: n._retired ? 'rgb(206, 206, 206)' : '',
              cursor: 'pointer',
              minWidth: '150px',
            }}
          >
            {timestampInSecondToDateUTCDDMMYYYYHHmm(
              n._productionDateEnd,
              this.props.i18n
            )}
          </TableCell>
          <TableCell>
            <Button
              onClick={event => {
                let [
                  co2QuantityInUserUnitPdf,
                  userUnitPdf,
                ] = convertKilogramsInUserUnit(n.co2SavedTemp, user);
                this.handleGenerateCertificatePdf(
                  n,
                  n._resourceName,
                  n._ownerName,
                  n._owner,
                  co2QuantityInUserUnitPdf,
                  userUnitPdf,
                  t,
                  this.props.i18n
                );
              }}
            >
              <img
                src={certificateLogo}
                alt={'Download certificate ' + n._certificateId}
                title={'Download certificate ' + n._certificateId}
                style={{ width: 24, height: 24 }}
              />
            </Button>
          </TableCell>
          {this.state.certificatesType ===
            enums.CertificatesTypes.CONSUMPTION.value &&
            userRelatedUtilityOrganization &&
            userRelatedUtilityOrganization.matchingType &&
            userRelatedUtilityOrganization.matchingType._id.toString() ===
              MATCHING_TYPE_HOURLY_DAILY_ID && (
              <TableCell>
                {n.frequency === enums.FrequencyTypes.DAILY &&
                  n.utilityOrganization &&
                  n.utilityOrganization.type ===
                    enums.OrganizationTypes.UTILITY &&
                  n.utilityOrganization.matchingType.toString() ===
                    MATCHING_TYPE_HOURLY_DAILY_ID && (
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={event => {
                        this.handleOpenHourlyCertificatesDialog(n);
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  )}
              </TableCell>
            )}
          <TableCell>
            <a href={`${explorerUrl}/tx/${n._txHash}`} target="_blank">
              <img
                src={blockchainLogo}
                alt="check transaction"
                title="check transaction"
                style={{ width: 24, height: 24 }}
              />
            </a>
          </TableCell>
          <TableCell>{this.renderSecretWordButton(n, t)}</TableCell>
        </TableRow>
      );
    });
  }

  renderIrecsList(irecs) {
    const { rowsPerPage, page, loading, loadingCo2, loadingIrecs } = this.props;

    if (loading || loadingCo2 || loadingIrecs) {
      return false;
    }

    let sliceToDisplay = irecs
      ? irecs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : [];

    return sliceToDisplay.map((n, index) => {
      const isSelected = this.isSelected(n.id);

      return (
        <TableRow
          hover
          role="checkbox"
          aria-checked={isSelected}
          tabIndex={-1}
          key={index}
          selected={isSelected}
        >
          <TableCell
            style={{
              cursor: 'pointer',
            }}
          >
            {n.country}
          </TableCell>
          <TableCell
            numeric
            style={{
              cursor: 'pointer',
            }}
          >
            {n.year}
          </TableCell>
          <TableCell
            style={{
              cursor: 'pointer',
            }}
          >
            {n.asset}
          </TableCell>
          <TableCell
            style={{
              cursor: 'pointer',
            }}
          >
            {n.customerOrganization ? n.customerOrganization.name : ''}
          </TableCell>
          <TableCell
            numeric
            style={{
              cursor: 'pointer',
            }}
          >
            {n.volume}
          </TableCell>
          <TableCell
            style={{
              cursor: 'pointer',
            }}
          >
            <Button
              onClick={() =>
                this.handleDownloadIrecFile(
                  n.fileName,
                  n.customerOrganization._id
                )
              }
            >
              {n.fileName}
            </Button>
          </TableCell>
        </TableRow>
      );
    });
  }

  renderCertificate() {}

  renderCertificatesChartCard(certificatesWithCo2) {
    const { classes, t } = this.props;

    return (
      <Grid item xs={12} sm={12}>
        <Card
          className={classes.card}
          style={{
            minHeight: 469,
            marginTop: 30,
            width: '100%',
          }}
        >
          <CardHeader
            avatar={<img src={chartIcon} style={{ maxHeight: 20 }} />}
            title={t('Monthly generated certificates')}
            subheader={t(
              'The quantity of green energy allocated each month, in MWh'
            )}
          />

          <CardContent
            style={{
              height: 300,
            }}
          >
            {this.renderCertificatesChart(certificatesWithCo2)}
          </CardContent>
        </Card>
      </Grid>
    );
  }

  renderCertificatesChart(certificatesWithCo2) {
    const { classes, unit, stacked, loading, loadingCo2, t, i18n } = this.props;

    if (
      loading ||
      loadingCo2 ||
      !certificatesWithCo2 ||
      (certificatesWithCo2 && certificatesWithCo2.length <= 0)
    ) {
      return <CircularProgress size={16} style={{ marginLeft: 10 }} />;
    }
    let myChartCertificates = certificatesWithCo2.map(
      certificate => certificate
    );

    myChartCertificates = myChartCertificates.sort((a, b) => {
      return a._productionDateEnd - b._productionDateEnd;
    });

    let currentMonth = timestampInSecondToMonthUTC(
      myChartCertificates[0]._productionDateEnd
    );

    const myChartLabels = myChartCertificates
      .map((certificate, index) => {
        let certificateMonth = timestampInSecondToMonthUTC(
          certificate._productionDateEnd
        );
        if (certificateMonth === currentMonth && index > 0) {
          return null;
        } else {
          currentMonth = certificateMonth;
          return certificateMonth;
        }
      })
      .filter(month => {
        return month !== null;
      });

    let momentLocale = 'en';
    if (i18n.language === 'fr') {
      momentLocale = 'fr';
    }
    const myChartLabelsTxt = myChartLabels.map(month => {
      let year = moment(month, 'MM-YYYY').format('YY');
      let monthIndex = moment(month, 'MM-YYYY').format('M');
      return `${
        moment.localeData(momentLocale).monthsShort()[monthIndex - 1]
      }-${year}`;
    });

    const myChartData = myChartLabels.map(month => {
      let monthlyProduction = 0;
      myChartCertificates.map(certificate => {
        if (
          timestampInSecondToMonthUTC(certificate._productionDateEnd) === month
        ) {
          monthlyProduction += certificate._powerInW / 1000000;
        }
      });
      return monthlyProduction;
    });

    const data = {
      labels: myChartLabelsTxt,
      datasets: [
        {
          label: 'Green energy certificates generated in MWh',
          data: myChartData,
          backgroundColor: 'rgba(248,119,51,0.9)',
          borderColor: 'rgba(248,119,51,1)',
          borderWidth: 1,
        },
      ],
    };

    return (
      <Bar
        ref={ref => {
          this.myCertificatesBarChart = ref;
        }}
        data={data}
        height={400}
        options={{
          maintainAspectRatio: false,
          responsive: true,
          animation: {
            duration: 1,
            onComplete: function() {
              var chartInstance = this.chart,
                ctx = chartInstance.ctx;

              ctx.font = Chart.helpers.fontString(
                Chart.defaults.global.defaultFontSize,
                Chart.defaults.global.defaultFontStyle,
                Chart.defaults.global.defaultFontFamily
              );
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';

              this.data.datasets.forEach(function(dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach(function(bar, index) {
                  var data =
                    dataset.data[index] > 1
                      ? Math.round(dataset.data[index])
                      : Math.round(dataset.data[index] * 100) / 100;

                  ctx.font = 'Inter-Regular';
                  ctx.fillStyle = 'rgba(0, 0, 0, 0.54)';
                  ctx.fillText(data + ' MWh', bar._model.x, bar._model.y);
                });
              });
            },
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                gridLines: { display: false, drawBorder: false },
              },
            ],
            yAxes: [
              {
                gridLines: { display: false, drawBorder: false },
                display: true,
                ticks: {
                  display: false,
                  max: Math.max(...myChartData) * 1.05,
                },
                //ticks: { display: false }
                //ticks: {
                //  beginAtZero:true
                //}
              },
            ],
          },
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                return data['labels'][tooltipItem[0]['index']];
              },
              label: function(tooltipItem, data) {
                return Math.round(tooltipItem.yLabel).toLocaleString() + ' MWh';
              },
            },
          },
        }}
      />
    );
  }

  triggerWarning() {
    this.props.toggleWarningMatchingDialog();
    this.props.getCertificatesForDate(this.props.matchingDate);
  }

  renderYearlyCertificates() {
    const { loadingCo2, loading, allCertificates, t } = this.props;
    let activeCertificates = allCertificates.filter(c => !c._retired);
    let yearArray = activeCertificates.map(certificate => {
      return moment.unix(certificate._productionDateEnd).format('YYYY');
    });

    let yearArrayWithoutDuplicates = Array.from(new Set(yearArray));

    let ascendingSortedYearArray = yearArrayWithoutDuplicates.sort(function(
      a,
      b
    ) {
      return a - b;
    });

    if (loading || loadingCo2) {
      return (
        <div>
          <Typography variant="body2" style={{ margin: 10, color: '#CECECE' }}>
            <FiClock
              style={{ position: 'relative', top: 3, marginRight: 10 }}
            />
            {t('Loading')}
          </Typography>
        </div>
      );
    } else {
      return ascendingSortedYearArray.map(year => {
        return (
          <span key={year}>
            <Button
              onClick={event => {
                this.handleGenerateYearlyCertificatePdfForTheNtLastYear(
                  allCertificates,
                  year,
                  t
                );
              }}
            >
              <img
                src={certificateLogo}
                alt={'Download yearly certificate'}
                title={'Download certificate'}
                style={{ width: 24, height: 24 }}
              />
              &nbsp;
              {year}
            </Button>
          </span>
        );
      });
    }
  }

  render() {
    const {
      classes,
      certificates,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      dialogSecretWordOpen,
      dialogLoadingPdfOpen,
      currentCertificateSecretWord,
      loading,
      loadingCo2,
      loadingSecretWord,
      retiringCertificateId,
      username,
      user,
      co2Data,
      t,
      i18n,
      matchingFrequency,
      irecs,
      loadingIrecs,
      loadingHourlyCertificates,
      hourlyCertificates,
    } = this.props;
    const emptyRows = certificates
      ? rowsPerPage -
        Math.min(rowsPerPage, certificates.length - page * rowsPerPage)
      : 0;

    const certificatesWithCo2 = certificates;

    let dateTimeFormat = 'YYYY-MM-DD HH:mm'; //English date
    if (i18n.language === 'fr') {
      dateTimeFormat = 'DD-MM-YYYY HH:mm';
    } else if (i18n.language === 'en_us') {
      dateTimeFormat = 'MM-DD-YYYY h:mm a'; //American date
    }

    let co2Unit = getUserKgOrPoundsOfCo2Unit(user);

    return (
      <div className={classes.root}>
        {!user.roles.includes(enums.UserRole.SUPER_ADMIN) &&
          this.renderYearlyCertificates()}
        <Paper className={classes.root}>
          <Tabs
            onSelect={(currentTab, lastTab) =>
              this.handleCertificatesTypeChange(currentTab)
            }
            selectedIndex={this.state.certificatesType}
          >
            <TabList className={classes.tabList}>
              <Tab
                className={classes.tab}
                disabledClassName={classes.tabDisabled}
                selectedClassName={classes.tabSelected}
              >
                {' '}
                {t(enums.CertificatesTypes.CONSUMPTION.label)}{' '}
              </Tab>
              {(user.roles.includes(enums.UserRole.SUPER_ADMIN) ||
                user.roles.includes(enums.UserRole.ADMIN)) && (
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  {' '}
                  {t(enums.CertificatesTypes.PRODUCTION.label)}{' '}
                </Tab>
              )}
              {(user.roles.includes(enums.UserRole.SUPER_ADMIN) ||
                (user.user_metadata.organization.type ===
                  enums.OrganizationTypes.UTILITY &&
                  user.user_metadata.organization.displayIrecs) ||
                (user.user_metadata.organization.type ===
                  enums.OrganizationTypes.CUSTOMER &&
                  user.user_metadata.organization.parentOrganization
                    .displayIrecs)) && (
                <Tab
                  className={classes.tab}
                  disabledClassName={classes.tabDisabled}
                  selectedClassName={classes.tabSelected}
                >
                  {' '}
                  {t(enums.CertificatesTypes.IREC.label)}{' '}
                </Tab>
              )}
            </TabList>
          </Tabs>
          {this.state.certificatesType ===
          enums.CertificatesTypes.IREC.value ? (
            <IrecsToolbar
              numSelected={selected.length}
              loading={this.props.loading}
              loadingCo2={this.props.loadingCo2}
              loadingIrecs={this.props.loadingIrecs}
              t={t}
            />
          ) : (
            <CertificatesToolbar
              numSelected={selected.length}
              loading={this.props.loading}
              loadingCo2={this.props.loadingCo2}
              t={t}
              i18n={i18n}
              user={user}
              co2Data={co2Data}
              matchingFrequency={this.props.matchingFrequency}
              certificates={certificates}
              certificatesType={this.state.certificatesType}
              loadingIrecs={this.props.loadingIrecs}
            />
          )}
          <div className={classes.tableWrapper}>
            <Table className={classes.table}>
              {this.state.certificatesType ===
              enums.CertificatesTypes.IREC.value ? (
                <IrecsHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={this.handleSelectAllClick}
                  onRequestSort={this.handleRequestSort}
                  rowCount={certificates ? certificates.length : 0}
                  username={username}
                  user={user}
                  t={t}
                  i18n={i18n}
                />
              ) : (
                <CertificatesHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={this.handleSelectAllClick}
                  onRequestSort={this.handleRequestSort}
                  rowCount={certificates ? certificates.length : 0}
                  username={username}
                  user={user}
                  t={t}
                  i18n={i18n}
                  certificatesType={this.state.certificatesType}
                  userRelatedUtilityOrganization={
                    this.props.userRelatedUtilityOrganization
                  }
                />
              )}
              <TableBody>
                {loadingCo2 || loading || loadingIrecs ? (
                  <Typography
                    variant="body2"
                    style={{ margin: 10, color: '#CECECE' }}
                  >
                    <FiClock
                      style={{ position: 'relative', top: 3, marginRight: 10 }}
                    />
                    {t('Loading')}
                  </Typography>
                ) : (
                  ''
                )}
                {(!certificatesWithCo2 ||
                  (certificatesWithCo2 &&
                    certificatesWithCo2.length <= 0 &&
                    !(loadingCo2 || loading))) &&
                this.state.certificatesType !==
                  enums.CertificatesTypes.IREC.value ? (
                  <Typography
                    variant="body2"
                    style={{ margin: 10, color: '#CECECE' }}
                  >
                    <img
                      src={certificateIcon}
                      style={{
                        maxHeight: 20,
                        position: 'relative',
                        top: 3,
                        marginRight: 10,
                      }}
                    />
                    {t('No certificates yet')}
                  </Typography>
                ) : (
                  ''
                )}
                {(!irecs || (irecs && irecs.length <= 0 && !loadingIrecs)) &&
                this.state.certificatesType ===
                  enums.CertificatesTypes.IREC.value ? (
                  <Typography
                    variant="body2"
                    style={{ margin: 10, color: '#CECECE' }}
                  >
                    <img
                      src={certificateIcon}
                      style={{
                        maxHeight: 20,
                        position: 'relative',
                        top: 3,
                        marginRight: 10,
                      }}
                    />
                    {t('No iRecs yet')}
                  </Typography>
                ) : (
                  ''
                )}
                {this.state.certificatesType ===
                enums.CertificatesTypes.IREC.value
                  ? this.renderIrecsList(irecs)
                  : this.renderCertificatesList(certificatesWithCo2)}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={certificates ? certificates.length : 0}
            labelDisplayedRows={({ from, to, count }) =>
              from + '-' + to + t(' of ') + count
            }
            labelRowsPerPage={t('RowsPerPage')}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        {this.state.certificatesType !== enums.CertificatesTypes.IREC.value && (
          <Grid container spacing={12}>
            {this.renderCertificatesChartCard(certificatesWithCo2)}
          </Grid>
        )}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Transfer certificate</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Select the new owner of the certificate, then validate
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Email Address"
              type="email"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Subscribe
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          fullScreen={false}
          open={dialogLoadingPdfOpen}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {t('Generating your PDF...')}
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" gutterBottom>
              {t('Loading the data, please wait')}{' '}
              <CircularProgress size={16} style={{ paddingLeft: 10 }} />
            </Typography>
          </DialogContent>
        </Dialog>

        <Dialog
          fullScreen={false}
          open={dialogSecretWordOpen}
          onClose={this.props.toggleSecretWordDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {loadingSecretWord && t('Loading secret word...')}
            {!loadingSecretWord &&
              t(
                'This is the secret used to anonymize your data in the Blockchain.'
              )}
          </DialogTitle>
          <DialogContent>
            {loadingSecretWord && (
              <CircularProgress size={16} style={{ paddingLeft: 10 }} />
            )}

            {!loadingSecretWord && (
              <Typography variant="body2" gutterBottom>
                {t('Production asset')}
              </Typography>
            )}
            {!loadingSecretWord && (
              <Typography variant="body2" gutterBottom>
                <img
                  src={lockIcon}
                  alt={'Secret word'}
                  title={'Secret word'}
                  style={{ width: 16, height: 16 }}
                />{' '}
                {currentCertificateSecretWord.productionAssetSecretWord}
              </Typography>
            )}

            {!loadingSecretWord &&
              currentCertificateSecretWord.consumptionAssetSecretWord !==
                currentCertificateSecretWord.productionAssetSecretWord && (
                <Typography variant="body2" gutterBottom>
                  {t('Consumption asset')}
                </Typography>
              )}
            {!loadingSecretWord &&
              currentCertificateSecretWord.consumptionAssetSecretWord !==
                currentCertificateSecretWord.productionAssetSecretWord && (
                <Typography variant="body2" gutterBottom>
                  <img
                    src={lockIcon}
                    alt={'Secret word'}
                    title={'Secret word'}
                    style={{ width: 16, height: 16 }}
                  />{' '}
                  {currentCertificateSecretWord.consumptionAssetSecretWord}
                </Typography>
              )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleSecretWordDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen={false}
          open={this.props.dialogHourlyCertificatesOpen}
          onClose={this.props.toggleHourlyCertificatesDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {t('Hourly matching data')}
          </DialogTitle>
          <DialogContent>
            {this.state.certificatesType ===
              enums.CertificatesTypes.CONSUMPTION.value && (
              <div>
                {loadingHourlyCertificates && (
                  <CircularProgress size={16} style={{ paddingLeft: 10 }} />
                )}

                {!loadingHourlyCertificates &&
                  (!hourlyCertificates ||
                    (hourlyCertificates && hourlyCertificates.length == 0)) && (
                    <Typography variant="body2" gutterBottom>
                      {t('No hourly data to display')}
                    </Typography>
                  )}

                {!loadingHourlyCertificates &&
                  hourlyCertificates &&
                  hourlyCertificates.length > 0 && (
                    <Table className={classes.table} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Date Start (UTC)</TableCell>
                          <TableCell>Date End (UTC)</TableCell>
                          <TableCell align="right">Power (kWh)</TableCell>
                          <TableCell align="right">
                            Avoided CO2 ({co2Unit})
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {hourlyCertificates.map(hourlyCertificate => {
                          let [
                            co2QuantityInUserUnitHour,
                            userUnit,
                          ] = convertKilogramsInUserUnit(
                            hourlyCertificate.co2SavedTemp,
                            user
                          );
                          return (
                            <TableRow key={hourlyCertificate._certificateId}>
                              <TableCell component="th" scope="row">
                                {moment(hourlyCertificate._productionDateStart)
                                  .utc()
                                  .format(dateTimeFormat)}
                              </TableCell>
                              <TableCell align="right">
                                {moment(hourlyCertificate._productionDateEnd)
                                  .utc()
                                  .format(dateTimeFormat)}
                              </TableCell>
                              <TableCell align="right">
                                {(
                                  hourlyCertificate._powerInW / 1000
                                ).toLocaleString('en-US')}
                              </TableCell>
                              <TableCell align="right">
                                {co2QuantityInUserUnitHour.toLocaleString(
                                  'en-US'
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  )}
              </div>
            )}

            {this.state.certificatesType ===
              enums.CertificatesTypes.PRODUCTION.value && (
              <Typography variant="body2" gutterBottom>
                {t('No data to display for the moment')}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.toggleHourlyCertificatesDialog}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/*this.renderCreateButton()*/}
      </div>
    );
  }
}

Certificates.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  assetsConsumingReducer,
  certificatesReducer,
  router,
  loginReducer,
  utilsReducer,
  dashboardReducer,
  usersReducer,
}) => {
  const {
    currentAsset,
    certificates,
    allCertificates,
    loading,
    retiringCertificateId,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    dialogMatchingDateOpen,
    dialogMatchingWarningOpen,
    dialogSecretWordOpen,
    dialogHourlyCertificatesOpen,
    currentCertificateSecretWord,
    loadingSecretWord,
    matchingDate,
    loadingMatching,
    generateCertificatesChecked,
    forceCertificatesGenerationChecked,
    loadingCheckCertificates,
    existingCertificates,
    dialogLoadingPdfOpen,
    irecs,
    loadingIrecs,
    hourlyCertificates,
    loadingHourlyCertificates,
    userRelatedUtilityOrganization,
    lastCertificatesDataLoad,
  } = certificatesReducer;

  const { yearToDateAssetsData } = assetsConsumingReducer;
  const { location } = router;
  const { co2Data, loadingCo2 } = utilsReducer;
  const { isAuthenticated, username, user } = loginReducer;
  const { matchingFrequency } = dashboardReducer;

  return {
    currentAsset,
    certificates,
    allCertificates,
    loading,
    loadingCo2,
    retiringCertificateId,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    location,
    isAuthenticated,
    username,
    user,
    co2Data,
    dialogMatchingDateOpen,
    dialogMatchingWarningOpen,
    dialogSecretWordOpen,
    dialogHourlyCertificatesOpen,
    currentCertificateSecretWord,
    loadingSecretWord,
    matchingDate,
    loadingMatching,
    generateCertificatesChecked,
    forceCertificatesGenerationChecked,
    loadingCheckCertificates,
    existingCertificates,
    yearToDateAssetsData,
    dialogLoadingPdfOpen,
    matchingFrequency,
    irecs,
    loadingIrecs,
    hourlyCertificates,
    loadingHourlyCertificates,
    userRelatedUtilityOrganization,
    lastCertificatesDataLoad,
  };
};

const mapDispatchToProps = {
  getCertificatesStart,
  certificatesTypeChanged,
  sortCertificates,
  changePage,
  changeRowsPerPage,
  generateCertificatePdf,
  retireCertificate,
  getCo2Data,
  toggleMatchingDateDialog,
  setMatchingDate,
  matching,
  toggleGenerateMatchingCertificates,
  toggleForceCertificatesGeneration,
  toggleWarningMatchingDialog,
  toggleSecretWordDialog,
  toggleHourlyCertificatesDialog,
  getHourlyCertificatesForDailyCertificate,
  getSecretWordForCertificate,
  getCertificatesForDate,
  generateYearlyCertificatePdf,
  downloadIrecFile,
  getIrecsStart,
  getUserRelatedUtilityOrganization,
  setLastCertificatesDataLoad,
};

Certificates = withStyles(styles, { name: 'Certificates' })(Certificates);
Certificates = translate('translations')(Certificates);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Certificates)
);



// WEBPACK FOOTER //
// ./src/components/Certificates.js